import { HubCoreService, localForageHelper } from '@/hub-shared'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import SpidermanService from '@services/spiderman/spiderman.service'

export default class SocialNetworksService extends MainService {
  hubCore = new HubCoreService()
  spider = new SpidermanService()
  logService = new LogService()

  public async renewToken(hash: string, network: string, idInstagram: string) {
    try {
      const regexToken = new RegExp('[&|?|#]id_token=(.*?)[&|\r|\n]') // eslint-disable-line
      const JWT = regexToken.exec(hash) ? regexToken.exec(hash)[1] : false
      if (!JWT) {
        return await this.hubCore.renewToken(hash, network, idInstagram)
      }
      throw new Error('JWT not found')
    } catch (error) {
      this.logService.error({ message: 'AuthService', error })
      throw error?.data
    }
  }

  public async addSocialNetwork(hash, network = null, id = null) {
    try {
      const regexToken = new RegExp('[&|?|#]id_token=(.*?)[&|\r|\n]') // eslint-disable-line
      const JWT = regexToken.exec(hash) ? regexToken.exec(hash)[1] : false
      if (!JWT && hash) {
        return await this.hubCore.bindSocialNetwork(hash, network, id)
      }
      if (!hash) {
        await localForageHelper.removeItem('actions')
      }
    } catch (error) {
      this.logService.error({ message: 'Error to add social network', error })
      throw error
    }
  }
}
